import React, { useEffect, useState } from 'react';
import emailjs from '@emailjs/browser';
import AdBanner from '../components/AdBanner';
import './ContactPage.css';

function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    document.title = '문의하기 - 로또운세';
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // EmailJS로 이메일 전송
      const result = await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID || 'YOUR_SERVICE_ID',
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'YOUR_TEMPLATE_ID',
        {
          from_name: formData.name,
          from_email: formData.email,
          subject: formData.subject,
          message: formData.message,
          to_email: 'contact@zipyo.kr',
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'YOUR_PUBLIC_KEY'
      );

      console.log('Email sent successfully:', result.text);
      alert('✅ 문의가 성공적으로 전송되었습니다!\n빠른 시일 내에 답변드리겠습니다.');

      // 폼 초기화
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      console.error('Email sending failed:', error);
      alert('❌ 문의 전송에 실패했습니다.\n잠시 후 다시 시도해주세요.\n\n직접 문의: contact@zipyo.kr');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-header">
        <h1>📧 문의하기</h1>
        <p>로또운세 서비스에 대한 문의사항을 남겨주세요</p>
      </div>

      <AdBanner />

      <div className="contact-content">
        <div className="contact-info">
          <div className="info-card">
            <div className="info-icon">✉️</div>
            <h3>이메일 문의</h3>
            <p>contact@zipyo.kr</p>
            <span className="response-time">평균 응답 시간: 영업일 기준 1-3일</span>
          </div>

          <div className="info-card">
            <div className="info-icon">❓</div>
            <h3>자주 묻는 질문</h3>
            <ul className="faq-list">
              <li><strong>Q:</strong> 로또 번호가 저장되나요?</li>
              <p><strong>A:</strong> 브라우저 로컬 스토리지에만 저장되며 서버에는 저장되지 않습니다.</p>

              <li><strong>Q:</strong> 운세는 언제 업데이트되나요?</li>
              <p><strong>A:</strong> 매일 새벽 3시(KST)에 자동으로 생성됩니다.</p>

              <li><strong>Q:</strong> 로또 당첨번호는 언제 업데이트되나요?</li>
              <p><strong>A:</strong> 매주 토요일 20:55분 업데이트 합니다.</p>
            </ul>
          </div>

          <div className="info-card">
            <div className="info-icon">🔒</div>
            <h3>개인정보 보호</h3>
            <p>
              제출하신 정보는 문의 처리 목적으로만 사용되며,
              답변 완료 후 1년간 보관 후 파기됩니다.
            </p>
          </div>
        </div>

        <div className="contact-form-container">
          <h2>문의 양식</h2>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">이름 *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="이름을 입력하세요"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">이메일 *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="example@email.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">제목 *</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
                placeholder="문의 제목을 입력하세요"
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">문의 내용 *</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="8"
                placeholder="문의하실 내용을 자세히 작성해주세요"
              />
            </div>

            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? '전송 중...' : '📨 문의 보내기'}
            </button>
          </form>
        </div>
      </div>

      <AdBanner />
    </div>
  );
}

export default ContactPage;
